import { useAtomValue } from 'jotai';

import { IsGraphClawHubMockEnabledAtom } from './state/atoms';

export const useGraphClawHubMockMode = (): boolean => {
	return useAtomValue(IsGraphClawHubMockEnabledAtom);
};
